import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Select from "react-select";

const AddShipment = ({ showAdd, handleCloseAdd }) => {
  const CFSOptions = [
    { value: 1, label: "CFS 1" },
    { value: 2, label: "CFS 2" },
    { value: 3, label: "CFS 3" },
    { value: 4, label: "CFS 4" },
    { value: 5, label: "CFS 5" },
    { value: 6, label: "CFS 6" },
    { value: 7, label: "CFS 7" },
    { value: 8, label: "CFS 8" },
    { value: 9, label: "CFS 9" },
    { value: 10, label: "CFS 10" },
    { value: 11, label: "CFS 11" },
    { value: 12, label: "CFS 12" },
    { value: 13, label: "CFS 13" },
    { value: 14, label: "CFS 14" },
    { value: 15, label: "CFS 15" },
    { value: 16, label: "CFS 16" },
    { value: 17, label: "CFS 17" },
    { value: 18, label: "CFS 18" },
    { value: 19, label: "CFS 19" },
    { value: 20, label: "CFS 20" },
  ];
  return (
    <>
      <Offcanvas show={showAdd} onHide={handleCloseAdd} placement={"end"}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add Shipment</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="row">
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              Airline
              </label>
              <div className="d-flex gap-2">
              <input
                type="text"
                name=""
                id=""
                className="form-control form-control-sm"
              />
              <Select className="custom-selector " />
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              Flight No
              </label>
              <input
                type="text"
                name=""
                id=""
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              Flight / Inward Date
              </label>
              <input
                type="date"
                name=""
                id=""
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              IGM No
              </label>
              <input
                type="text"
                name=""
                id=""
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              IGM Date	
              </label>
              <input
                type="date"
                name=""
                id=""
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              MAWB No
              </label>
              <input
                type="text"
                name=""
                id=""
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              MAWB Date
              </label>
              <input
                type="date"
                name=""
                id=""
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              HAWB No
              </label>
              <input
                type="text"
                name=""
                id=""
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              HAWB Date
              </label>
              <input
                type="date"
                name=""
                id=""
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              Line No.
              </label>
              <input
                type="text"
                name=""
                id=""
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              Packages
              </label>
              <div className="d-flex gap-2">
              <input
                type="text"
                name=""
                id=""
                className="form-control form-control-sm"
              />
              <Select className="custom-selector " />
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              Gross Wt
              </label>
              <div className="d-flex gap-2">
              <input
                type="text"
                name=""
                id=""
                className="form-control form-control-sm"
              />
              <Select className="custom-selector " />
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              Net Wt
              </label>
              <div className="d-flex gap-2">
              <input
                type="text"
                name=""
                id=""
                className="form-control form-control-sm"
              />
              <Select className="custom-selector " />
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              Volume
              </label>
              <div className="d-flex gap-2">
              <input
                type="text"
                name=""
                id=""
                className="form-control form-control-sm"
              />
              <Select className="custom-selector " />
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              Chargeable Wt
              </label>
              <div className="d-flex gap-2">
              <input
                type="text"
                name=""
                id=""
                className="form-control form-control-sm"
              />
              <Select className="custom-selector " />
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <label htmlFor="pickuptype" className="form-label text-label-red">
              Marks & Nos
              </label>
              <input
                type="text"
                name=""
                id=""
                className="form-control form-control-sm"
              />
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2 mt-5">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit"
                        // onClick={handleClose}
                        >
                            Submit
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Save & New
                        </button>
                        <button className="btn btn-light text-xs" type="submit" onClick={handleCloseAdd}>
                            Close
                        </button>
                    </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AddShipment;
